

















































import { useBoutique } from '@checkout/composables';
import { useCheckoutStore } from '@checkout/stores';
import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'BoutiqueSelector',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'toggle'],
  setup() {
    const { boutiquesList, getFormatedDistance, setSelectedBoutique } =
      useBoutique();
    const checkoutStore = useCheckoutStore();
    const { selectedBoutique } = storeToRefs(checkoutStore);

    onMounted(() => {
      const isSelectedBoutiqueExists = boutiquesList.value.some(
        (b) => b.id === selectedBoutique.value?.id
      );

      if (!isSelectedBoutiqueExists) {
        setSelectedBoutique(boutiquesList.value[0]);
      }
    });

    return {
      boutiquesList,
      selectedBoutique,
      getFormatedDistance
    };
  }
});
